/**
 * Password rules shown in the UI (SEC-08). The API enforces the full policy
 * (12+ characters, not a common password, not containing your email, not
 * one of your last 5); this mirrors the length and shows the API's messages.
 */
export const MIN_PASSWORD_LENGTH = 12;

export const passwordLengthRule = {
  value: MIN_PASSWORD_LENGTH,
  message: `Use at least ${MIN_PASSWORD_LENGTH} characters.`,
};

/** The API's password-policy messages from a failed request, if any. */
export const passwordErrorsFromResponse = (err: any): string | null => {
  const data = err?.response?.data;
  if (Array.isArray(data?.errors) && data.errors.length > 0) {
    return data.errors.join(" ");
  }
  if (typeof data?.message?.error === "string") {
    return data.message.error;
  }
  return null;
};
